import { makeStyles } from "@material-ui/core/styles";
const useStyles = makeStyles((theme) => ({
  menu: {
    display: "none",
    [theme.breakpoints.down('sm')]: {
      display: "block",
    },
  },
  footerHead: {
    display: "flex",
    justifyContent: "space-between",
    fontSize: "1rem",
    backgroundColor: "transparent",
    fontWeight: 600,
    padding: "1rem 10rem",
    [theme.breakpoints.down('lg')]: {
      padding: "1rem 5rem",
    },
    [theme.breakpoints.down('sm')]: {
      padding: "1rem 1rem",
      display: "none",
    },
  },
  contactContainer: {
    color: theme.agentTheme.card.secondary_foreground,
    display: "flex",
    alignItems: "center",
    gap: "1rem",
    "&>span": {
      display: "flex",
      alignItems: "center",
    },
  },
  becomeExpertBtn: {
    color: theme.agentTheme.primary?.foreground,
    backgroundColor: theme.agentTheme.primary?.main,
    fontWeight: 600,
    textTransform: "none",
    borderRadius: 4,
    boxShadow:'none',
    padding: "10px 24px",
    "&:hover": {
       boxShadow:'none',
        backgroundColor: theme.agentTheme.primary?.main,
        color: theme.agentTheme.primary?.foreground,
    },
  },
  loginContainer: {
    color: theme.agentTheme.text.link_text_color,
    display:'flex',
  },
  loginButton: {
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    color: theme.agentTheme.card.secondary_foreground,
  },
  menuIcon: {
    cursor: "pointer",
    color: theme.agentTheme.text.link_text_color,
  },
  logo: {
    height: "49px",
    width: "140px",
    objectFit: "contain",
  },
  logoImg: {
    height: "50px",
    maxWidth: "120px",
    width: "100%",
    cursor: "pointer",
  },
  footerTail: {
    backgroundColor: "transparent",
    display: "flex",
    justifyContent: "space-between",
    padding: "5px 20rem",
    [theme.breakpoints.down('lg')]: {
      padding: "1rem 5rem",
      flexDirection: "column",
      gap: "1rem",
    },

    [theme.breakpoints.down('sm')]: {
      padding: "10px 1rem",
      flexDirection: "row",
      justifyContent: "start",
    },
  },
  navbar: {
    display: "flex",
    justifyContent: "start",
    alignItems: "center",
    gap: "2rem",
    fontSize: "1rem",
    color: theme.agentTheme.text.link_text_color,
    [theme.breakpoints.down('sm')]: {
      display: "none",
    },
  },
  hoverItem: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: theme?.agentTheme?.text?.link_text_color,
    "&:hover": {
      color: theme?.agentTheme?.secondary?.main,
    },
  },
  navItem: {
     color: theme?.agentTheme?.text?.link_text_color,
    fontWeight: 700,
    letterSpacing: "0.05rem",
    "&:hover": {
    color: theme?.agentTheme?.secondary?.main,
    },
  },
  contentTextSideNavbar: {
    fontWeight: 500,
    fontSize: "16px",
    color: theme.agentTheme.card.link_foreground,
    marginRight: "50px",
    cursor: "pointer",
    margin: theme.spacing(1, 0, 1, 1),
    display: "flex",
  },

  navbarContentContainer: {
    display: "flex",
    alignItems: "center",
    width: "60%",
    marginLeft: "16px",
    borderBottom: `0.5px solid ${theme.agentTheme.card.muted_foreground}`,
  },

  mobileNavDrawer: {
    display: "flex",
    flexDirection: "column",
    backgroundColor: theme.agentTheme.card.main,
    height: "100vh",
    width: "100%",
    paddingTop: "5px",
    overflowY: "scroll",
    WebkitOverflowScrolling: "touch",
  },

  closeBtn: {
    marginRight: "40px",
  },

  closeIcon: {
    color: theme.agentTheme.card.link_foreground,
  },

  usernameText: {
    color: theme.agentTheme.card.link_foreground,
    marginLeft: "8px",
  },
  drawerContainer: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    overflowY: "auto",
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
}));

export default useStyles;
